import { render, staticRenderFns } from "./MobileNavigation.vue?vue&type=template&id=56a89f64&scoped=true"
import script from "./MobileNavigation.js?vue&type=script&lang=js&external"
export * from "./MobileNavigation.js?vue&type=script&lang=js&external"
import style0 from "./MobileNavigation.vue?vue&type=style&index=0&id=56a89f64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a89f64",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotIcon: require('/home/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Atoms/Icon/Icon.vue').default})
